const endpoint = 'checkout/order';

export default [ 'api', function (api) {
  return {
    generateOrder: basket_id => {
      return api.post(`${endpoint}/generate/${basket_id}`)
        .then(response => response.data);
    },
    retrieveOrder: basket_id => {
      return api.get(`${endpoint}/${basket_id}`)
        .then(response => response.data);
    },
    updateOrder: order => {
      return api.post(endpoint, order)
        .then(response => response.data);
    },
    submitTransaction: (basket_id, transaction) => {
      return api.post(`${endpoint}/transaction/${basket_id}`, transaction)
        .then(response => response.data);
    }
  };
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/order/services/api.order.service.js